export const EXPORT_ROUTER = {
    REPORT_DOWNLOAD_CENTER: '/download/manager/center',
    REPORT_DOWNLOAD_CENTER_NEW: '/download/manager/centerNew',
};
